import { CommonModule } from '@angular/common';
import { ComponentFactoryResolver, DOCUMENT, Type } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { SingleSeriesFundChartModule } from 'ChartApp/ts/features/single-series-fund-chart/single-series-fund-chart.module';
import { ConfigModule } from 'NewAngular/config/config.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { HistoricalDataTableModule } from 'SecuritiesApp/ts/features/historical-data-table/historical-data-table.module';
import { SecurityHeaderControlModule } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.module';
import { SingleSeriesFundChartComponent } from 'ChartApp/ts/features/single-series-fund-chart/single-series-fund-chart.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { SideMenuComponent } from 'NewAngular/features/components/side-menu/side-menu.component';
import { HistoricalDataTableComponent } from 'SecuritiesApp/ts/features/historical-data-table/historical-data-table.component';
import { SecurityHeaderControlComponent } from 'SecuritiesApp/ts/features/security-header-control/security-header-control.component';
import { getLogger } from 'NewAngular/state/logger';
import { DoVariableBootstrap } from 'SecuritiesApp/ts/extendable-classes/do-variable-bootstrap';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
const entryComponents = [
    HistoricalDataTableComponent,
    SideMenuComponent,
    SecurityHeaderControlComponent,
    SingleSeriesFundChartComponent,
    TopBarNavComponent,
];
export class IndicatorsQuoteModule extends DoVariableBootstrap {
    constructor(_document, componentFactoryResolver) {
        super(_document, componentFactoryResolver, entryComponents);
        this.nonSingularComponents = [HistoricalDataTableComponent, SingleSeriesFundChartComponent];
    }
}
IndicatorsQuoteModule.ɵfac = function IndicatorsQuoteModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IndicatorsQuoteModule)(i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(i0.ComponentFactoryResolver)); };
IndicatorsQuoteModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: IndicatorsQuoteModule });
IndicatorsQuoteModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        FormsModule,
        ConfigModule,
        CommonModule,
        HistoricalDataTableModule,
        NavigationModule,
        SecurityHeaderControlModule,
        SingleSeriesFundChartModule,
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
